export const CLOSED_SUCCESSFULLY = 1001;
export const CLOSED_FAIL = 1002;
